import { RPCs } from "../../../services/rpc.js";
import { getTHERMSImageThumbnailUrl } from "../../Files/utils/get-therms-image-thumbnail-url.js";
import { SelectMultiOptionWrapper } from "../../../components/Select/SelectMultiOptionWrapper.js";
import { SelectAsyncRPC } from "../../../components/Select/SelectAsyncRPC.js";
import { SelectGroupListItem } from "../../../components/Select/SelectGroupListItem.js";
import { SelectGroupValueSingle } from "../../../components/Select/SelectGroupValueSingle.js";
import { SelectGroupValueMulti } from "../../../components/Select/SelectGroupValueMulti.js";
import "react";
import { Avatar, Button } from "@therms/atalaya";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
import { atom, useAtom } from "jotai";
// src/modules/Users/shared/SelectUserAndGroupForCommunications.tsx
var activeGroupAtom = atom("user");
var UserBase = ({ user }) => {
	if (!user) return null;
	const { avatarUrl, label, status, title } = user;
	return /* @__PURE__ */ jsxs("div", {
		className: "space-x-base flex items-center",
		children: [/* @__PURE__ */ jsx(Avatar, {
			url: getTHERMSImageThumbnailUrl(avatarUrl),
			circular: true,
			statusColor: status?.color || void 0,
			size: "xs"
		}), /* @__PURE__ */ jsxs("div", {
			className: "truncate",
			children: [/* @__PURE__ */ jsx("div", {
				className: "text-color-subtle truncate text-sm",
				children: title
			}), /* @__PURE__ */ jsx("div", {
				className: "truncate",
				children: label
			})]
		})]
	});
};
var UserSelectedSingle = (user) => /* @__PURE__ */ jsx(UserBase, { user });
var UserSelectedMulti = ({ onRemove, user }) => /* @__PURE__ */ jsx(SelectMultiOptionWrapper, {
	onRemove,
	children: /* @__PURE__ */ jsx("div", {
		className: "px-sm max-w-full",
		children: /* @__PURE__ */ jsx(UserBase, { user: { ...user } })
	})
});
var UserListItem = (userOption) => /* @__PURE__ */ jsx(UserBase, { user: userOption });
var SelectedSingle = (props) => props.type === "user" ? /* @__PURE__ */ jsx(UserSelectedSingle, { ...props }) : /* @__PURE__ */ jsx(SelectGroupValueSingle, {
	color: props.color,
	label: props.label
});
var SelectedMulti = (props, onRemove) => props.type === "user" ? /* @__PURE__ */ jsx(UserSelectedMulti, {
	onRemove,
	user: props
}) : /* @__PURE__ */ jsx(SelectGroupValueMulti, {
	color: props.color,
	label: props.label,
	onRemove
});
var ListItem = (props) => props.type === "user" ? /* @__PURE__ */ jsx(UserListItem, { ...props }) : /* @__PURE__ */ jsx(SelectGroupListItem, {
	color: props.color,
	label: props.label
});
var MenuList = ({ children }) => {
	const [activeGroup, setActiveGroup] = useAtom(activeGroupAtom);
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs("div", {
		className: "space-x-xs bg-surface-strong p-xs sticky top-0 flex",
		children: [/* @__PURE__ */ jsx(Button, {
			className: classnames({ "bg-main-faded": activeGroup === "user" }, "flex-1"),
			disabled: activeGroup === "user",
			fullWidth: true,
			onClick: () => {
				if (setActiveGroup) setActiveGroup("user");
			},
			subtle: true,
			variant: "main",
			children: "Users"
		}), /* @__PURE__ */ jsx(Button, {
			className: classnames({ "bg-main-faded": activeGroup === "user-group" }, "flex-1"),
			disabled: activeGroup === "user-group",
			onClick: () => {
				if (setActiveGroup) setActiveGroup("user-group");
			},
			subtle: true,
			variant: "main",
			children: "Groups"
		})]
	}), children] });
};
var responseOptionsExtractor = (data) => data?.usersAndGroups;
var SelectUserAndGroupForCommunications = ({ idFilter, limit = 25, multi, value, ...atalayaSelectProps }) => {
	const [activeGroup] = useAtom(activeGroupAtom);
	return /* @__PURE__ */ jsx(SelectAsyncRPC, {
		RenderMenuList: MenuList,
		RenderListItem: ListItem,
		RenderSelectedMulti: SelectedMulti,
		RenderSelectedSingle: SelectedSingle,
		args: {
			idFilter,
			typeFilter: activeGroup
		},
		idProp: "id",
		limit,
		multi,
		optionLabelExtractor: ({ label }) => label,
		optionValueExtractor: ({ id }) => id,
		request: RPCs.Users.GetUsersAndGroupsForCommunicationsList.v1,
		requestFilterProp: "idFilter",
		responseOptionsExtractor,
		value,
		...atalayaSelectProps
	});
};
export { SelectUserAndGroupForCommunications };

//# sourceMappingURL=SelectUserAndGroupForCommunications.js.map